/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconNumber5 = createReactComponent("outline", "number-5", "IconNumber5", [["path", { "d": "M8 20h4a4 4 0 1 0 0 -8h-4v-8h8", "key": "svg-0" }]]);

export { IconNumber5 as default };
//# sourceMappingURL=IconNumber5.mjs.map
